import { mergeAttributes, Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import Component from './PhraseToken.vue'

export default Node.create({
  name: 'personalizer',
  group: 'inline',
  inline: true,
  atom: true,
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      phraseId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-phrase-id'),
        renderHTML: (attributes) => {
          if (!attributes.phraseId) {
            return {}
          }

          return {
            'data-phrase-id': attributes.phraseId
          }
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-phrase-id]'
      }
    ]
  },

  renderHTML({ node, HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes)]
  },

  addCommands() {
    return {
      setPersonalizer:
        (phraseId) =>
        ({ tr, commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: {
              phraseId
            }
          })
    }
  },

  addNodeView() {
    return VueNodeViewRenderer(Component)
  }
})
